export function arrayFromEnum(arrEnum: any) {
    return Array.from(Array(Object.values(arrEnum).filter((element) => !isNaN(Number(element))).length), (e, i) => i);
}

export function arrayFromEnumHighestEducation(arrEnum: any) {
    return [1, 2, 5, 6, 7];
}
